import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// v3.14 - Disabled service worker auto-reload to prevent refresh loops
// Service workers are unregistered in index.html to ensure clean state

const rootElement = document.getElementById("root");

// Use hydrate if pre-rendered HTML exists (from react-snap), otherwise use render
if (rootElement.hasChildNodes()) {
  // Pre-rendered content exists - hydrate it
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // No pre-rendered content - render normally
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
